function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var investmentItemListItemEntities = function investmentItemListItemEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byMarketCountryIdIn: {},
    byTypeIdAndMarketCountryIdIn: {},
    byIndustryIdAndMarketCountryIdIn: {},
    byInvestmentItemId: {},
    byInvestmentItemWatchListItemsId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_INVESTMENTITEMLISTITEMSBYMARKETCOUNTRYIDIN_SUCCESS:
      var embedded = action.response._embedded;
      var byMarketCountryIdIn = _objectSpread({}, state.byMarketCountryIdIn);
      var key = action.marketCountryIds.join(",");
      byMarketCountryIdIn[key] = embedded && embedded.investmentItemListItems;
      if (!embedded) return Object.assign({}, state, {
        byMarketCountryIdIn: byMarketCountryIdIn
      });
      var byInvestmentItemId = _objectSpread({}, state.byInvestmentItemId);
      embedded.investmentItemListItems.forEach(function (listItem) {
        byInvestmentItemId[listItem.investmentItemId] = listItem;
      });
      return Object.assign({}, state, {
        byMarketCountryIdIn: byMarketCountryIdIn,
        byInvestmentItemId: byInvestmentItemId
      });
    case ActionTypes.GET_WATCHLISTITEMLISTITEMSBYUSERID_SUCCESS:
      var byInvestmentItemWatchListItemsId = _objectSpread({}, state.byInvestmentItemWatchListItemsId);
      action.response.forEach(function (watchlistItemListItem) {
        return merge(byInvestmentItemWatchListItemsId, watchlistItemListItem.investmentItemListItemByInvestmentItemWatchListItemsId);
      });
      return merge({}, state, {
        byInvestmentItemWatchListItemsId: byInvestmentItemWatchListItemsId
      });
    case ActionTypes.GET_INVESTMENTITEMSVIEWBYMARKETCOUNTRYIDIN_SUCCESS:
      var byMarketCountryIdIn = action.response.investmentItemListItemsByMarketCountryIdIn;
      var byTypeIdAndMarketCountryIdIn = action.response.investmentItemListItemsByTypeIdAndMarketCountryIdIn;
      var byIndustryIdAndMarketCountryIdIn = action.response.investmentItemListItemsByIndustryIdAndMarketCountryIdIn;
      return merge({}, state, {
        byMarketCountryIdIn: byMarketCountryIdIn,
        byTypeIdAndMarketCountryIdIn: byTypeIdAndMarketCountryIdIn,
        byIndustryIdAndMarketCountryIdIn: byIndustryIdAndMarketCountryIdIn
      });
    default:
      return state;
  }
};
export default investmentItemListItemEntities;